import { render, staticRenderFns } from "./UserRoleListComponent.vue?vue&type=template&id=ac7762c8"
import script from "./UserRoleListComponent.vue?vue&type=script&lang=js"
export * from "./UserRoleListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports